<tui-elastic-container *transloco="let t">
  <pxc-patient-edit
    data-testid="patient-edit"
    [clientCode]="clientCode"
    [displayActionButtons]="false"
    [(patient)]="patient"
    (formValidityUpdate)="isPatientCreationFormValid$.next($event)" />

  <div class="mt-4 flex justify-between gap-2">
    <button appearance="outline" data-testid="patient-cancel" tuiButton type="button" (click)="cancel()">
      {{ t('Annuler') }}
    </button>
    <button
      data-testid="patient-confirm"
      tuiButton
      type="button"
      [disabled]="(isPatientCreationFormValid$ | async) === false"
      (click)="createPatient()">
      {{ t('Ajouter') }}
    </button>
  </div>
</tui-elastic-container>
